import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import ServiceDescription from "@/Components/Front/Blocks/ServiceDescription";
import ServicesHero from "@/Components/Front/Blocks/ServicesHero";
import WebpImage from "@/Components/Front/Blocks/WebpImage";
import WhatWeOffer from "@/Components/Front/Blocks/WhatWeOffer";
import FrontText from "@/Components/Front/FrontText";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { useTranslation, Trans } from "react-i18next";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const LogisticsConsultancy = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();

    return (
        <FrontLayout breadcrumbs={[
            { title: t('breadcrumbs.services'), current: false, href: resolveLocaleRoute('front.services', null, i18n.resolvedLanguage) },
            { title: t('breadcrumbs.logisticsConsultancy'), current: true },
        ]}>
            <FrontSeoMetaTags seo={seo}/>
            <section>
                <ServicesHero icon={'/storage/icons/service-package-icon.svg'} title={t('breadcrumbs.logisticsConsultancy')} />
                <ServiceDescription contentKey={'services.logisticsConsultancyEntryText'} lng={i18n.resolvedLanguage}>
                    <WebpImage
                        className='rounded-10 mt-5 w-full h-[295px] object-cover'
                        sources={[
                            {
                                width: 768,
                                path: '/storage/images/consulting-size-530',
                                mime: '/jpg'
                            },
                            {
                                width: 375,
                                path: '/storage/images/consulting-size-375',
                                mime: '/jpg'
                            },
                            {
                                width: 1,
                                path: '/storage/images/consulting',
                                mime: 'jpg'
                            }
                        ]}
                        alt={t('services.leaseRenegotiationsHeading')}
                        fallback={`/storage/images/consulting.jpg`}
                        seo={{
                            width: 520,
                            height: 295
                        }}
                    />
                </ServiceDescription>
            </section>
            <section>
                <Container>
                    <Row>
                        <Column>
                            <FrontText className="text-center mb-10 font-domine font-bold text-dark-blue" textSize={'38/43-m-24/27'}>
                                <h2>{t('services.logisticsConsultancyH2')}</h2>
                            </FrontText>
                        </Column>
                    </Row>
                    <WhatWeOffer itemsKey={`services.logisticsConsultancyOffer`} />
                </Container>
            </section>
            <Container>
                <Row className={`xl:mb-c120 lg:mb-25 md:mb-20 mb-15 justify-between gap-y-10`}>
                    <Column xl={5} lg={5} md={6}>
                        <FrontText className="mb-5 font-bold text-dark-blue" textSize={'20/24'}>
                            <h3>{t('services.logisticsConsultancyH3First')}</h3>
                        </FrontText>
                        <FrontText className="" textSize={'16/20'}>
                            <p>{t('services.logisticsConsultancyH3Desc')}</p>
                        </FrontText>
                    </Column>
                    {/* <Column xl={5} lg={5} md={6}>
                        <FrontText className="mb-5 font-bold text-dark-blue" textSize={'20/24'}>
                            <h3>{t('services.logisticsConsultancyH3First')}</h3>
                        </FrontText>
                        <FrontText className="" textSize={'16/20'}>
                            <p>{t('services.logisticsConsultancyH3Desc')}</p>
                        </FrontText>
                    </Column> */}
                </Row>
            </Container>
            {/* <section>
                <Container>
                    <Row>
                        <AcfImageWithContent
                            heading={`Przykładowy tekst z informacjami do uzupełnienia`}
                            title={`PRZYKŁADOWY TEKST`}
                            description={`Nasza firma specjalizuje się w projektowaniu i budowie magazynów dostosowanych do indywidualnych potrzeb klientów. Niezależnie od tego, czy potrzebujesz magazynu dla swojej firmy produkcyjnej, dystrybucyjnej czy logistycznej, nasz zespół doświadczonych profesjonalistów zapewni Ci kompleksowe wsparcie na każdym etapie procesu. Kiedy rozpoczynamy projekt BTS (build-to-suit), dbamy o to, aby być z Tobą na każdym etapie procesu. Nasz zespół projektowy będzie śledził postępy, dostarczał regularne aktualizacje i uwzględniał Twoje uwagi i sugestie. Naszym celem jest zapewnienie pełnej transparentności i zapewnienie, że jesteś zaangażowany w każdym kroku projektu.`}
                            graphql={false}
                            sourcesWebp={[
                                {
                                    width: 530,
                                    path: '/storage/images/bts-size-530',
                                    mime: '/jpg'
                                },
                                {
                                    width: 375,
                                    path: '/storage/images/bts-size-375',
                                    mime: '/jpg'
                                },
                                {
                                    width: 1,
                                    path: '/storage/images/bts',
                                    mime: 'jpg'
                                }
                            ]}
                            fallbackWebp={`/storage/images/bts.jpg`}
                        />
                    </Row>
                </Container>
            </section> */}
            {/* <section>
                <Container>
                    <Row>
                        <AcfFeaturesList
                            list={[
                                {
                                    title: `Nasze projekty BTS`,
                                    description: `to gwarancja funkcjonalności i optymalizacji przestrzeni. Dzięki naszemu podejściu skrojonego na miarę, możemy dostosować magazyn do Twoich potrzeb biznesowych. Od projektowania układu magazynu, przez wybór odpowiednich technologii i rozwiązań logistycznych, aż po budowę i dostosowanie do standardów bezpieczeństwa - wszystko to znajdziesz w naszej ofercie.`
                                },
                                {
                                    title: `Nasze projekty BTS`,
                                    description: `to gwarancja funkcjonalności i optymalizacji przestrzeni. Dzięki naszemu podejściu skrojonego na miarę, możemy dostosować magazyn do Twoich potrzeb biznesowych. Od projektowania układu magazynu, przez wybór odpowiednich technologii i rozwiązań logistycznych, aż po budowę i dostosowanie do standardów bezpieczeństwa - wszystko to znajdziesz w naszej ofercie.`
                                },
                                {
                                    title: `Nasze projekty BTS`,
                                    description: `to gwarancja funkcjonalności i optymalizacji przestrzeni. Dzięki naszemu podejściu skrojonego na miarę, możemy dostosować magazyn do Twoich potrzeb biznesowych. Od projektowania układu magazynu, przez wybór odpowiednich technologii i rozwiązań logistycznych, aż po budowę i dostosowanie do standardów bezpieczeństwa - wszystko to znajdziesz w naszej ofercie.`
                                },
                                {
                                    title: `Nasze projekty BTS`,
                                    description: `to gwarancja funkcjonalności i optymalizacji przestrzeni. Dzięki naszemu podejściu skrojonego na miarę, możemy dostosować magazyn do Twoich potrzeb biznesowych. Od projektowania układu magazynu, przez wybór odpowiednich technologii i rozwiązań logistycznych, aż po budowę i dostosowanie do standardów bezpieczeństwa - wszystko to znajdziesz w naszej ofercie.`
                                },
                                {
                                    title: `Nasze projekty BTS`,
                                    description: `to gwarancja funkcjonalności i optymalizacji przestrzeni. Dzięki naszemu podejściu skrojonego na miarę, możemy dostosować magazyn do Twoich potrzeb biznesowych. Od projektowania układu magazynu, przez wybór odpowiednich technologii i rozwiązań logistycznych, aż po budowę i dostosowanie do standardów bezpieczeństwa - wszystko to znajdziesz w naszej ofercie.`
                                },
                                {
                                    title: `Nasze projekty BTS`,
                                    description: `to gwarancja funkcjonalności i optymalizacji przestrzeni. Dzięki naszemu podejściu skrojonego na miarę, możemy dostosować magazyn do Twoich potrzeb biznesowych. Od projektowania układu magazynu, przez wybór odpowiednich technologii i rozwiązań logistycznych, aż po budowę i dostosowanie do standardów bezpieczeństwa - wszystko to znajdziesz w naszej ofercie.`
                                },
                            ]}
                        />
                    </Row>
                </Container>
            </section> */}
            <section className="xl:mb-c120 lg:mb-25 md:mb-20 mb-15">
                <FrontOurTeamCards agents={agents} />
            </section>
        </FrontLayout>
    )
}

export default LogisticsConsultancy;